// @flow

import { useTranslator } from '@gandi/translate';

import { Button } from '@gandi/ui';

export function ActionsButton({
  isMobile,
  handleClose,
  handleDelete,
  isLoading,
}: {
  isMobile: boolean,
  handleClose: () => void,
  handleDelete: () => void,
  isLoading: boolean,
}): React.MixedElement {
  const { __ } = useTranslator();

  const buttonProps = {
    small: true,
    kind: isMobile ? 'default' : 'link',
  };

  return (
    <>
      <Button
        {...buttonProps}
        intent="danger"
        onClick={handleDelete}
        loading={isLoading}
      >
        {__('Delete')}
      </Button>
      <Button
        {...buttonProps}
        kind={isMobile ? 'outline' : 'link'}
        onClick={handleClose}
      >
        {__('Cancel')}
      </Button>
    </>
  );
}
